// This is just an example,
// so you can safely delete all default props below

export default {
  ls: '_de',
  new: "Übermittelt",
  notAnonymText: ' Ich möchte Kontaktdaten angeben',
  anonymText: 'Ich möchte anonym bleiben',
  anonymTextInfo: '<b>Wichtig</b>Es besteht keine gesetzlichte Pflicht anonymen Hinweisen nachzugehen.',
  notAnonymNote: 'Ihr Hinweis wird <b>nicht</b> anonym behandelt.<br>Sie erhalten Statusaktualisierungen an die angegebene E-Mail.',
  resetDefaultTexts: 'Sofort Nachrichten zurücksetzen',
  required: '* Pflichtfeld',
  designText: 'Design',
  savedIdent: 'Identifikationsnummer gespeichert',
  saved: 'Gespeichert',
  designTextMsg: 'Legen Sie Ihr Corporate Design fest: Anzeigename, Farbe, Schriftfarbe, Logo',
  mainFontColor: 'Schriftfarbe',
  mainColor: 'Farbe',
  copiedToClipboard: 'Kopiert!',
  confirmTransferNote: 'Ich habe den Sicherheitshinweis gelesen und verstanden.',
  beforeTransferNoteText: '<b>WICHTIG!</b> Merken Sie sich dieses Passwort. Es kann nicht wiederhergestellt oder geändert werden.',
  beforeTransferNoteTextMsg: 'Nach übermittlung erhalten Sie eine eindeutige Identifikationsnummer. ',
  transferNoteText: 'Identifkationsnummer',
  transferNoteTextMsg1: '<b>WICHTIG!</b> Speichern Sie sich diese Identifkationsnummer!',
  transferNoteTextMsg2: 'Der Hinweis kann nur mit der <b>eindeutigen Identifikationsnummer und Ihrem gewählten Passwort</b> überprüft werden!',
  transferNote: 'Sicherheitshinweis',
  newMsg: "Vielen Dank. Ihr Hinweis wurde erfolgreich übermittelt und wird nun innerhalb der nächsten 7 Tage auf die Anwendbarkeit des Hinweisgeberschutzgesetztes geprüft.",
  review: "In Prüfung",
  reviewMsg: "Vorfall wird auf die Anwendbarkeit des Hinweisgeberschutzgesetzes geprüft.",
  approved: "Angenommen",
  approvedMsg: "Die Anwendbarkeit wurde festgestellt. Vorfall wird geprüft.",
  notApproved: "Abgelehnt",
  notApprovedMsg: "Die Anwendbarkeit wurde NICHT festgestellt. Hinweise abgelehnt.",
  waitingOnWhistleblower: "Warten auf Hinweisgeber",
  waitingOnResearch: "Nachforschung",
  transfering: "Wird übermittelt...",
  missingConfirm: "Bestätigen Sie den SICHERHEITSHINWEIS",
  name_prop: 'name_de',
  advanced: 'Erweitert',
  chat: 'Nachforschung',
  replied: "Neue Nachricht",
  done: "Abgeschlossen",
  archived: "Archiviert",
  incidents: 'Hinweise',
  header: 'Kopfzeile',
  headerLogo: 'Logo',
  addContact: 'Kontakt hinzufügen',
  addContactMsg: 'Fügen Sie einen Kontakt zur Nachforschung hinzu.',
  name: 'Name',
  add: 'Hinzufügen',
  contacts: 'Kontakte',
  recoveryCodeMsg: 'Make a copy and store it in a safe place. It will be necessary if you lose your password to recover the access to your account without data loss.',
  successUpload: 'Upload erfolgreich',
  errorUpload: 'Fehler beim Upload',
  errorSaving: 'Fehler beim Speichern',
  incident: 'Hinweis',
  tenant: 'Mandant',
  tenantOverview: 'Mandanten',
  transfered: 'Übermittelt',
  subject: 'Grund',
  newincidentNote: '',
  daysLeft: 'Tage verbleibend',
  description: 'Beschreibung',
  needFileUpload: 'Ich haben Dateien als Beweis und/oder Nachweis zum Übermitteln',
  needFileUploadNote: 'Aus Sicherheitsgründen können Dateien erst nach positiver Freigabe hochgeladen werden.<br/>Deshalb beschreiben Sie bitte um welche Art von Dateien es sich handelt (Dateiformat, Größe, Inhalt, etc.)',
  newincident: 'Hinweis übermitteln',
  color_new: "red",
  color_active: "blue",
  color_review: "blue",
  color_approved: "blue",
  color_notApproved: "grey-3",
  color_waitingOnWhistleblower: "blue",
  color_replied: "orange",
  color_waitingOnResearch: "yellow",
  color_done: "green",
  color_archived: "black",
  forReview: 'Neue Hinweise',
  where: 'Wo',
  who: 'Wer',
  addUserMsg: '',
  setupSuccessText: 'Einrichtung abgeschlossen!',
  setupSuccessTextMsg: 'Wir haben Ihrem Administrator einen Aktivierungslink an die angegebene E-Mail-Adresse gesendet.',
  setup: 'Einrichtung',
  setupText: 'Willkommen',
  setupTextMsg: 'Wir freuen uns Sie bei  bei VaDok &reg; Whistleblower begrüßen zu dürfen.<br/><br/>Wir benötigen den Namen Ihrer Organisation und Kontaktinformationen Ihres Administrators.',
  adminEmailText: 'Nach der Einrichtung senden wir Ihrem Administrator einen Aktivierungslink an die angegebene E-Mail-Adresse. Administratoren sind ausschließlich berechtigt das System zu verwalten. Administratoren dürfen keine Hinweise lesen oder prüfen. Nach erfolgreicher Aktivierung hat der Administrator die Möglichkeit, weitere Benutzer hinzuzufügen. ',
  confirmSetup: 'Ich habe den Infotext gelesen und verstanden.',
  accepTerms: 'Wenn Sie auf "Weiter" klicken, stimmen Sie den Allgemeine Geschäftsbedingungen, der Datenschutzrichtlinie und dem SaaS-Vertrag von VaDok &reg; Whistleblower zu.',
  continue: 'Weiter',
  doSetup: 'Bestätigen',
  when: 'Wann',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  resetPassword: 'Passwort setzen',
  resetPasswordMsg: 'Vergeben Sie ein Passwort',
  passwordConfirmText: 'Passwort wiederholen',
  overdue: 'Überfällig',
  fileUploadSubject: 'Dateien',
  text_color_new: "white",
  text_color_active: "white",
  text_color_done: "white",
  text_color_archived: "white",
  text_color_approved: "white",
  text_color_notApproved: "grey-8",
  text_color_review: "white",
  text_color_waitingOnWhistleblower: "white",
  text_color_replied: "black",
  text_color_waitingOnResearch: "black",

  icon_new: "feedback",
  icon_active: "forum",
  icon_done: "done_all",
  icon_archived: "archive",
  icon_approved: "done",
  icon_notApproved: "error",
  icon_review: "visibility",
  icon_waitingOnWhistleblower: "chat",
  icon_replied: "mark_chat_unread",
  icon_waitingOnResearch: "forum",
  preview: 'Vorschau',
  deny: 'Ablehnen',
  approve: 'Annehmen & Prüfen',
  identificationNumber: 'Identifikationsnummer',
  identificationNumberNote: 'Um Ihrer Anonymität sicherzustellen erhalten Sie für jeden Hinweis eine eindeutige Identifkationsnummer.',
  actionDeadline: 'Frist',
  state: 'Status',
  backToPartner: 'Zurück',
  description: 'Was ist passiert?',
  descriptionNote: 'Schreiben Sie eine klare und detaillierte Hinweismeldung, in der Sie den Vorfall oder Verstoß beschreiben. Geben Sie so viele relevante Informationen wie möglich an, ohne persönliche Daten preiszugeben.',
  who: 'Wer',
  fileUploadDisabled: 'Aus Sicherheitsgründen können Dateien erst nach Freigabe durch den Sachbearbeiter hochgeladen werden.<br/>Antworten Sie mit einer Beschreibung um welche Art von Dateien es sich handelt (Dateiformat, Größe, Inhalt, etc.)<br/><br/>Der Sachbearbeiter wird den Dateiupload nach Prüfung für Sie aktivieren.',
  whoNote: 'Wer war involviert/beteiligt?',
  when: 'Wann',
  whenNote: 'Zeitraum, Datum und/oder Uhrzeit. ',
  inspector: 'Prüfer',
  admin: 'Administrator',
  delete: 'Löschen',
  remove: 'Entfernen',
  usersText: 'Benutzer',
  usersTextMsg: 'Verwalten Sie Benutzer',
  username: 'Benutzername',
  manage: 'Verwalten',
  activate: 'Aktivieren',
  deactivate: 'Deaktivieren',
  role: 'Rolle',
  addUser: 'Benutzer hinzufügen',
  user: 'Sachbearbeiter',
  where: 'Wo',
  whereNote: 'Wo ereignete sich der Vorfall?',
  addNote: 'Als Notiz speichern',
  note: 'Notiz',
  files: 'Dateien',
  category: 'Kategorie',
  subCategory: 'Unterkategorie',
  mainCategory: 'Hauptkategorie',
  categoryNote: 'Legen Sie eine Kategorie für den Hinweis fest.',
  enableFileupload: 'Dateiupload',
  enable: 'Aktiveren',
  disable: 'Deaktivieren',
  securityText: 'Sicherheit',
  securityMsg: 'Passwort, 2-Faktor und Account-Recovery-Key',
  enableFileuploadNote: 'Aktivieren Sie den Dateiupload für den Hinweisgeber',
  pickFiles: 'Dateien hinzufügen',
  reply: 'Neue Nachricht',
  replyNote: 'Bleiben Sie anonym, sachlich und vertraulich.',
  send: 'Antworten',
  reportedAt: 'Übermittelt am',
  deadlineDone: 'Rückmeldung bis',
  deadlineReview: 'Prüfung bis',
  deadline: 'Zeitrahmen',
  replyAndComplete: 'Antworten & Vorfall abschließen',
  welcome: 'Willkommen, ',
  new: 'Hinweis übermittelt',
  inProgress: 'Wird bearbeitet',
  closed: 'Abgeschlossen',
  history: 'Verlauf',
  defaultText: 'Sofort Nachrichten',
  displayName: 'Anzeigename',
  logo: 'Logo',
  select: 'Auswählen...',
  defaultTextMsg: 'Nachrichten die beim jeweiligen Status automatisch gesendet werden.',
  settings: 'Konfiguration',
  whistleblower: 'Hinweisgeber',
  urlText: 'Kanäle für Hinweisgeber',
  urlTextMsg: 'Die Kanäle für Hinweisgeber zum Melden von Hinweisen',
  checkIncidentText: 'Hinweis öffnen',
  checkIncidentTextMsg: 'Sie haben bereits einen Hinweis übermittelt und wollen diesen öffnen? </br></br>Hier können Sie Informationen ergänzen, mit der beauftragten Vertrauensperson über einen Chat anonym sprechen und den Bearbeitungsstand einsehen.',
  checkIncident: 'Jetzt öffnen...',
  newIncidentText: 'Neuer Hinweis',
  newIncidentTextMsg1: 'Übermitteln Sie einen neuen Hinweis.',
  newIncidentTextMsg2: '',
  newIncidentTextPhoneMsg2: 'Alternativ können Sie in der Zeit von Montag bis Freitag zwischen 9 ‐ 17 Uhr unter nachfolgender Rufnummer anrufen und den Hinweis fernmündlich geben:',
  size: 'Größe',
  uploadedAt: 'Datum',
  upload: 'Upload',
  ext: 'Typ',
  attachment: 'Anhänge',
  successDownload: 'Download gestartet...',
  errorDownload: 'Fehler beim Download',
  attachmentNote: '',
  download: 'Download',
  downloaded: 'Heruntergeladen',
  fileUpload: 'Datei <file> hochgeladen.',
  addServiceProvider: 'Dienstleister hinzufügen',
  notDownloaded: 'Neu',
  save: 'Speichern',
  cancel: 'Abbrechen',
  confirm: 'Bestätigen',
  faq: 'FAQ - Häufige Fragen',
  newIncidentTextBanner: '<b>Wichtig!</b> Allgemeine Beschwerden (z.B. zu Vergaben oder Einstellungsverfahren), die nicht in Zusammenhang mit schwerwiegenden Verhaltens‐, Regel‐ oder Gesetzesverstößen stehen, richten Sie bitte an die jeweils zuständigen Kontaktpersonen im Unternehmen.',
  newIncident: 'Jetzt übermitteln...',
  passwordText: 'Passwort',
  userSettings: 'Benutzerkonfiguration',
  passwordTextMsg: 'Vergeben Sie ein Passwort mit Klein-, Großbuchstaben, Zahlen und Sonderzeichen. Mindestens 12 Zeichen.',
  legalText: 'Rechtliches',
  legalTextMsg: 'Organisationsnamen, Impressum, Datenschutz',
  companyName: 'Organisationsnamen',
  categoryText: 'Kategorien',
  categoryTextMsg: 'Verwaltung der Kategorien',
  currentIncidents: 'Aktive Hinweise',
  imprint: 'Impressum',
  dataprivacy: 'Datenschutz',
  policy: 'Policy',
  login: 'Anmelden',
  loginUrl: 'Meldestelle',
  authText: 'Anmelden',
  noTenantsFound: 'Keine Mandanten',
  serviceProviderId: 'Dienstleister ID:',
  check: 'Überprüfen',
  acceptServiceProvider: '<b>Sachbearbeiter-Zugriff</b> für den Dienstleister aktivieren.<br/>Der Dienstleister erhält KEINE Rechte zur Administration.',
  noTenantsFoundMsg: 'Sie werden derzeit nicht als Dienstleister eingesetzt.',
  loginFailed: 'Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihr Passwort und den Benutzernamen.',
  accessFailed: 'Authorisierung fehlgeschlagen. Bitte überprüfen Sie Ihr Passwort und die Identifikationsnummer.',
  loggedin: 'Angemeldet',
  authorized: 'Authorisiert',
  website: 'Webseite',
  emptyServiceProviders: 'Es sind derzeit keine Dienstleister angelegt',
  addServiceProviderMsg: 'Einen Dienstleister den <b>Sachbearbeiter-Zugriff</b> auf Ihr System erlauben. Tragen Sie die von Ihrem Dienstleister erhaltene ID ein und überprüfen Sie diese.<br/><br/>Bei erfolgreicher Prüfung können Sie den Dienstleister hinzufügen.',
  invalidServiceProviderId: 'Kein Dienstleister gefunden',
  serviceProvidersText: 'Dienstleister',
  serviceProvidersTextMsg: 'Dienstleister/Ombudsmann einbinden',
  authTextMsg: 'Bitte geben Sie Ihre Zugangsdaten an',
  authorization: 'Anmeldung',
  missingCategory: 'Kategorie muss angegeben werden!',
  newCategory_name_de: 'Kategorie',
  confirmMessageToWhistleblower: 'Wollen Sie folgende Nachricht an den <b>Hinweisgeber</b> übermitteln?',
  confirmMessage: 'Wollen Sie folgende Nachricht an die Meldestelle übermitteln?',
  confirmNote: 'Wollen Sie folgende Nachricht als <b>interne Notiz</b> speichern? Notizen sind nicht für den Hinweisgeber sichtbar.',
  confirmDone: 'Wollen Sie folgende Nachricht als <b>endgültige</b> Rückmeldung für den gemeldeten Hinweis übermitteln? Der Hinweis wird danach für die Bearbeitung geschlossen.',

  twoFactor: "2-Faktor Authentifizierung",
  twoFactorMsg: 'Aktivieren Sie die 2-Faktor Authentifizierung durch scannen des QR-Codes mit einer <b>Authentifizierung-App</b>. <br/>z.B. '
    + '<a class="fileurl" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Google Authentificator</a>'
    + ', <a class="fileurl" href="https://www.microsoft.com/de-de/security/mobile-authenticator-app" target="_blank">Microsoft Authentificator</a>'
    + ', <a class="fileurl" href="https://authy.com/download/" target="_blank" >Authy</a>, etc. '
    + '<br/>Bestätigen Sie den Scan durch die Eingabe des <b>in der App generierten zeitbasierten Schlüssels</b>.',
  confirmTwoFactor: 'Schlüssel',
  twoFactorInput: 'Schlüssel',
  notificationsText: 'Benachrichtigungen',
  notificationsMsg: 'Verwalten Sie Ihre Benachrichtigungen',
  userText: 'Benutzer',
  userMsg: 'Benutzername, Vor- und Nachname, E-Mail',
  twoFactorDisabled: '2-Faktor Authentifizierung NICHT aktiv',
  twoFactorEnabled: '2-Faktor Authentifizierung aktiv',
  twoFactorSettings: '2-Faktor Einstellungen',
  disableTwoFactor: 'Deaktivieren Sie die 2-Faktor Authentifizierung durch die Eingabe Ihres Passwortes.',
  confirmingTwoFactorFailed: 'Aktivierung der 2-Faktor Authentifizierung fehlgeschlagen!',
  disablingTwoFactorFailed: 'Deaktivierung der 2-Faktor Authentifizierung fehlgeschlagen!',
  twoFactorAuthMsg: 'Bestätigen Sie die Anmeldung durch die Eingabe des <b>in der App generierten zeitbasierten Schlüssels</b>.',
  month_01: 'Jan',
  month_02: 'Feb',
  month_03: 'Mär',
  month_04: 'Apr',
  month_05: 'Mai',
  month_06: 'Jun',
  month_07: 'Jul',
  month_08: 'Aug',
  month_09: 'Sep',
  month_10: 'Okt',
  month_11: 'Nov',
  month_12: 'Dez',
  others: 'Sonstiges',
  none: 'Keine',
  moreAs14Days: 'nicht Fällig',
  less14days: 'fällig in < 14 Tagen',
  less7days: 'fällig in < 7 Tagen',
  filterDate: 'Zeitraum',
  close: 'Schließen',
  finished: 'Abgeschlossen',
  found: 'Hinweise gefunden',
  clearFilter: 'Filter löschen',
  reset: 'Zurücksetzen',
  overview: 'Dashboard',
  notNotApproved: 'Nicht abgelehnt',

  contact: 'Kontaktdaten',
  firstname: 'Vorname',
  lastname: 'Nachname',
  adress1: 'Adresszeile 1',
  adress2: 'Adresszeile 2',
  zipCode: 'PLZ',
  city: 'Ort',
  country: 'Land',
  email: 'E-Mail',
  phone: 'Telefon',

  deadlineControlling: 'Fristen',

  accountRecovery: 'Konto-Wiederherstellung-Code',
  notEnabled: '<b>NICHT</b> aktiviert',
  enabled: 'Aktiviert',
  twoFactorDesc: 'Mit der Zwei-Faktor-Authentifizierung erhöhen Sie den Schutz für den Zugriff auf Ihr Konto.',
  accountRecoveryDesc: 'Sollten Sie Ihr Passwort verlieren, so können Sie <b>ausschließlich</b> mit Ihrem Konto-Wiederherstellungs-Code ein neues Passwort vergeben.',
  confirmPassword: 'Zur Sicherheit bestätigen Sie bitte Ihr Passwort',
  changePassworDesc: 'Hier können Sie Ihr Passwort ändern',
  changePassword: 'Passwort ändern',
  oldPassword: 'Altes Passwort',
  newPassword: 'Neues Passwort',
  invalidPassword: 'Besätigung fehlgeschlagen! Versuchen Sie es erneut.',
  securityNote: 'Sicherheitshinweis',
  passwordTip: 'Es ist von entscheidender Bedeutung, Passwörter sicher zu speichern, keinesfalls zu wiederholen und niemals weiterzugeben. Nutzen Sie einen Passwort-Manager für robuste, einzigartige Passwörter, um die Sicherheit Ihrer Konten zu gewährleisten.',
  passwordChanged: 'Passwort vergeben',
  passwordChangedText: 'Ihr Passwort wurde erfolgreich vergeben.',
  inspectorInfoText: 'Als Prüfer dürfen Sie ausschließlich den Fortschritt überprüfen, ohne Zugriff auf sensible Informationen oder Inhalte zu erhalten, um die Vertraulichkeit und die Integrität des Prüfungsprozesses durch die Sachbearbeiter/Ombudsmänner zu wahren. ',
  assignedTo: 'Zust. Sachbearbeiter',
  manageAccess: 'Zugriff verwalten',
  manageAccessText: 'Stellen Sie sicher, dass nur befugte Personen auf den Hinweis zugreifen können.',
  access: 'Zugriff',
  addChannel: 'Kanal hinzufügen',
  edit: 'Bearbeiten'
}

